export const baseURL = "https://roulettecasino.zekkolive.online/";
export const adminBaseURL = "https://newadmin.zekkolive.online/";
export const key = "SjqWTaltdsBTeGseZXpujUloxZLEglIchxo0ginPhzc=";
